import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7978ff26")

_pushScopeId("data-v-7978ff26")
const _hoisted_1 = {
  "data-testid": "urgent-rts-tab-root",
  class: "pt-4"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center" }
const _hoisted_3 = { class: "flex flex-row items-center gap-4" }
const _hoisted_4 = { class: "rts-table" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!
  const _component_UrgentRTSFilter = _resolveComponent("UrgentRTSFilter")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Detail = _resolveComponent("Detail")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Search, {
            placeholder: _ctx.$t('urgentDeliveryManagement.searchPlaceholder'),
            value: _ctx.parameters.search,
            onInput: _ctx.onSearch,
            onClear: _ctx.clearSearch,
            marginRight: "mr-0"
          }, null, 8, ["placeholder", "value", "onInput", "onClear"]),
          _createVNode(_component_TimeRangePicker, {
            onSelect: _ctx.onSetDateRange,
            startDate: _ctx.parameters.startDate,
            endDate: _ctx.parameters.endDate,
            isCloseDateAfterSelect: "",
            highlightOnSelected: true,
            customCalendar: true,
            customTotalMaxDate: 31,
            resetLimitOnSetOption: "",
            isDateAlignCenter: "",
            maxDate: new Date(),
            isSetMaxDate: "",
            placeholder: 
            _ctx.$t('urgentDeliveryManagement.rts.requestDatePlaceholder')
          ,
            class: "calender-style",
            showOptions: 
            `${_ctx.$t('custom')},${_ctx.$t('hari ini')},${_ctx.$t('7 hari terakhir')},${_ctx.$t(
              '30 hari terakhir'
            )}`
          ,
            customBackground: "bg-white"
          }, null, 8, ["onSelect", "startDate", "endDate", "maxDate", "placeholder", "showOptions"]),
          _createVNode(_component_UrgentRTSFilter, {
            currentParameters: _ctx.parameters,
            options: _ctx.lastLocationOptions,
            onApply: _ctx.onApplyFilter
          }, null, 8, ["currentParameters", "options", "onApply"])
        ]),
        _createVNode(_component_lp_button, {
          "icon-left": "download-new",
          title: _ctx.$t('urgentDeliveryManagement.downloadData'),
          textColor: "red-lp-300",
          customClass: "w-44",
          outline: "",
          small: "",
          class: "right-0",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDownload()))
        }, null, 8, ["title"])
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.controller.RTSList.length)
          ? (_openBlock(), _createBlock(_component_TableV2, {
              key: 0,
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => (_ctx.pagination = $event)),
              loading: _ctx.controller.isLoading,
              columns: _ctx.columns,
              data: _ctx.controller.RTSList,
              paginationStyle: "v3",
              pinnedSubstractHeight: "300px",
              onRequest: _cache[3] || (_cache[3] = () => _ctx.fetchList()),
              onClick: _ctx.goToDetail,
              isDetailAble: "",
              headerStyle: "v2",
              bgHeader: "bg-white",
              sortBy: _ctx.parameters.sortBy,
              sortDirection: _ctx.parameters.sortDirection,
              onSort: _ctx.onSort
            }, null, 8, ["pagination", "loading", "columns", "data", "onClick", "sortBy", "sortDirection", "onSort"]))
          : _createCommentVNode("", true),
        (!_ctx.controller.RTSList.length)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 1,
              customHeaderMessage: _ctx.emptyStateData.headerMessage,
              customMessage: _ctx.emptyStateData.message,
              icon: _ctx.emptyStateData.icon
            }, null, 8, ["customHeaderMessage", "customMessage", "icon"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives(_createVNode(_component_Detail, {
      data: _ctx.urgentDeliveryManagementDetailData,
      close: _ctx.closeDetail
    }, null, 8, ["data", "close"]), [
      [_vShow, _ctx.modalDetail]
    ])
  ], 64))
})